// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.usage-activity-timeline[data-v-7ff8f184] {\n    background-color: white;\n    max-width:96%;\n}\n", ""]);
// Exports
module.exports = exports;
